/**
 * Google Maps API Configuration
 * 
 * Centralized configuration for Google Maps API key across the application.
 * This key is used for:
 * - Google Places Autocomplete (location fields in forms)
 * - Google Maps (map view on vendor search)
 * 
 * Priority:
 * 1. Environment variable (VITE_GOOGLE_MAPS_API_KEY) - Best for security
 * 2. Fallback to existing hardcoded key - Already in use for location autocomplete
 */

// Existing API key (already used for Google Places Autocomplete)
const FALLBACK_API_KEY = import.meta.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyCmiTZu8oGRJ-yZVYPi7CLnzYWsMi-wkz8';

/**
 * Get Google Maps API key
 * Checks environment variable first, falls back to existing key
 * @returns {string} Google Maps API key
 */
export const getGoogleMapsApiKey = () => {
  // Try environment variable first (more secure for production)
  const envKey = import.meta.env?.VITE_GOOGLE_MAPS_API_KEY;
  
  if (envKey && envKey !== '' && !envKey.includes('your_')) {
    return envKey;
  }
  
  // Fallback to existing hardcoded key
  return FALLBACK_API_KEY;
};

/**
 * Google Places libraries to load
 */
export const GOOGLE_PLACES_LIBRARIES = ['places'];

/**
 * Google Maps libraries to load (includes places for autocomplete)
 */
export const GOOGLE_MAPS_LIBRARIES = ['places', 'maps'];

export default {
  apiKey: getGoogleMapsApiKey(),
  placesLibraries: GOOGLE_PLACES_LIBRARIES,
  mapsLibraries: GOOGLE_MAPS_LIBRARIES,
};
